import React from 'react';

import { IconProps } from '@shared/interfaces/icon.interface';

export const NotVerifiedIcon: React.FC<IconProps> = ({ width = 24, height = 24, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11.985 22.356s8.282-2.508 8.282-9.421c0-6.915.3-7.455-.365-8.12C19.238 4.15 13.071 2 11.985 2 10.899 2 4.73 4.15 4.066 4.815c-.664.665-.364 1.205-.364 8.12 0 6.913 8.283 9.421 8.283 9.421z"
        clipRule="evenodd"
      ></path>
      <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 15L9 9M9 15l6-6"></path>
    </svg>
  );
};
